import BarLoader from 'react-spinners/BarLoader';
import ClipLoader from 'react-spinners/ClipLoader';

import theme from 'utils/theme';

const color = theme.colors.red[500];

export const Loader = () => <BarLoader color={color} height={3} width="100%" />;

export const Full = () => (
  <div className="fixed top-0 left-0 w-screen h-screen z-50">
    <Loader />
    <div className="absolute right-0 top-0 m-8">
      <ClipLoader size={50} color={color} />
    </div>
  </div>
);

export const Middle = () => (
  <div className="flex flex-wrap w-1/3 mx-auto h-screen justify-center items-center">
    <Loader />
  </div>
);

export const Top = () => (
  <div className="flex flex-wrap w-1/3 mx-auto mt-10">
    <Loader />
  </div>
);

export default {
  Full,
  Loader,
  Middle,
  Top
};
